import { CodeArticleWithCid, CollectionName, PublicationSheetWithId } from '@livv/models';
import { getDocumentUrlByCollectionName } from '@livv/utils/helpers';
import { Grid, Typography } from '@mui/material';
import { FC } from 'react';
import getPreviewProps from '../utils/getPreviewProps';
import SearchCard from '@components/SearchCard';

export const GridContentMaxWidth = '62vw';

interface ContentsProps {
    contents: CodeArticleWithCid[] | PublicationSheetWithId[];
}

const Contents: FC<ContentsProps> = ({ contents }) => (
    <Grid direction="column" maxWidth={GridContentMaxWidth} spacing={2} container>
        {contents.map((content) => {
            const { docId, title, snippet } = getPreviewProps(content);

            return (
                <Grid
                    key={`book-node-content-preview-${docId}`}
                    data-test-id={`book-node-content-preview-${docId}`}
                    item
                >
                    <SearchCard
                        href={(() => {
                            const urlGetter = getDocumentUrlByCollectionName(
                                CollectionName.PUBLICATION_SHEETS ?? '',
                            );
                            if (urlGetter) {
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                return urlGetter(docId, content as any);
                            }

                            return '';
                        })()}
                    >
                        <Typography
                            data-test-id={`book-node-content-preview-title-${docId}`}
                            variant="h3"
                            gutterBottom
                        >
                            {title}
                        </Typography>
                        <Typography sx={{ color: 'grey.300' }}>{snippet}</Typography>
                    </SearchCard>
                </Grid>
            );
        })}
    </Grid>
);

export default Contents;
